<template>
  <div class="ma-6">
    <div class="d-flex w-full align-center">
      <OMenuButton :menuOpts="newRowOpts" right>
        <template v-slot="{ on }">
          <v-btn color="primary" v-on="on">Novo Produto...</v-btn>
        </template>
      </OMenuButton>

      <v-spacer />

      <OSwitch label="Mostrar inativos" v-model="includeInactive" />

      <v-spacer />

      <OMenuButton :menuOpts="menuOpts" />
    </div>

    <ODialog ref="detailsDialog" hideWhenLoading>
      <v-card v-if="selectedRow != null">
        <ODialogBar
          title="Produto"
          :subtitle="'#' + selectedRow.id"
          @close="$refs.detailsDialog.$dismiss()"
        />
        <v-card-text class="pa-3 maxh-4">
          <v-form v-model="isValid">
            <div class="d-flex flex-wrap children-pa-3">
              <OCapCont class="w-1/3" label="Tipo de Produto">
                <code>{{ selectedRow.type }}</code>
              </OCapCont>

              <OTextField
                class="w-2/3"
                label="Nome (na medição)"
                v-model="selectedRow.alias"
              />

              <OMoneyInput
                class="w-1/3"
                label="Valor mensalidade"
                v-model="selectedRow.monthlyValue"
              />

              <OMoneyInput
                class="w-1/3"
                label="Valor instalação"
                v-model="selectedRow.installValue"
              />

              <OMoneyInput
                class="w-1/3"
                label="Valor retirada"
                v-model="selectedRow.removeValue"
              />

              <div v-if="selectedRow.deletedAt != null" class="tag red ma-3">
                Desativado em
                {{ selectedRow.deletedAt | moment('DD/MMM/YYYY HH:mm') }}
              </div>
            </div>
          </v-form>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @cancel="$refs.detailsDialog.$dismiss()"
          @apply="save"
        />
      </v-card>
    </ODialog>

    <div class="mt-6">
      <OLoadingLine :absolute="true" :value="isLoading" />
      <ODataGrid
        v-if="gridData != null"
        class="report-grid dense-table"
        :data="gridData"
        @rowClicked="showRowDetails"
        selectable
        :selected="selectedIds"
      />
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'
import ODataGrid from 'oderon-vue/cpts/ODataGrid.vue'
import { preProcessSpec } from 'oderon-commons/src/tables'
import grid from 'oderon-commons/src/grid'
import { ProductType } from '../../../models/index'
import OMoneyInput from 'oderon-vue/cpts/OMoneyInput.vue'

export default {
  components: { ODataGrid, OMoneyInput },
  data() {
    return {
      EditStore,

      adapterSpec: preProcessSpec({
        defaultSortable: false,
        columns: [
          { t: 'ID|', d: 'id', w: 50, color: '#ccc' },
          { t: 'Tipo', d: (row) => [row.type], w: 150 },
          { t: 'Nome (na medição)', d: 'alias' },
          { t: 'Mensalidade|', d: 'monthlyValue', f: 'BRL', w: 150 },
          { t: 'Instalação|', d: 'installValue', f: 'BRL', w: 150 },
          { t: 'Retirada|', d: 'removeValue', f: 'BRL', w: 150 },
          {
            t: 'Desativado em|',
            d: 'deletedAt',
            f: { brDt: 'MM/DD/YYYY' },
            w: 150
          }
        ],
        rowStyleFn: ({row}) => {
          if (row.deletedAt != null) return { color: '#cccccc' }
        }
      }),

      isLoading: false,
      includeInactive: false,
      selectedIds: [],
      rows: [],
      selectedRow: null,
      isValid: true
    }
  },
  computed: {
    newRowOpts() {
      return [
        { text: 'Oderon Fox...', onClick: () => this.addProduct('oderon_fox') },
        { text: 'Câmera JIMI...', onClick: () => this.addProduct('camera') },
        { text: 'Teclado...', onClick: () => this.addProduct('keyboard') }
        // {
        //   text: 'Speaker (Jornada Falada)...',
        //   disabled: true,
        //   onClick: () => {}
        // }
      ]
    },

    menuOpts() {
      return [
        {
          text: 'Desativar...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.confirmDeactivate()
        },
        {
          text: 'Reativar...',
          icon: 'mdi-undo',
          disabled: this.selectedIds.length != 1,
          onClick: () => this.confirmReactivate()
        }
      ]
    },

    gridData() {
      return grid.generateWebGrid({
        rows: this.rows,
        spec: this.adapterSpec
      })
    }
  },
  watch: {
    'EditStore.row'() {
      this.reload()
    },
    'EditStore.currentTab'(x) {
      if (x == 'produtos') this.reload()
    },
    includeInactive() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let { rows } = await ProductType.findAll({
        includeInactive: this.includeInactive,
        costCenterIds: EditStore.row.id,
        limit: 100
      })

      this.rows = rows

      this.selectedIds = []
    },

    addProduct(type) {
      this.$loading(async () => {
        await ProductType.save({
          type,
          alias: type,
          costCenterId: EditStore.row.id
        })

        this.fetchData()
        this.$snack('Produto criado com sucesso')
      })
    },

    async showRowDetails(row) {
      this.selectedRow = null
      this.$refs.detailsDialog.$loading(async () => {
        this.selectedRow = await ProductType.findById(row.id)
      })

      return this.$refs.detailsDialog.$open()
      // const res = await this.$refs.detailsDialog.open(mailboxItem)
      // if (res === 'RELOAD') {
      //   this.fetchData()
      // }
    },

    async save() {
      this.$loading(async () => {
        this.$refs.detailsDialog.$dismiss()
        await ProductType.save(this.selectedRow)
        this.$snack('Salvo com sucesso')
        await this.fetchData()
      })
    },

    async confirmDeactivate() {
      let str = 'o produto selecionado'
      if (this.selectedIds.length > 1)
        str = `os ${this.selectedIds.length} produtos selecionados`

      let proceed = await this.$confirmDeactivate(`Deseja desativar ${str}?`)
      if (proceed) {
        this.$loading(async () => {
          for (let productId of this.selectedIds) {
            await ProductType.deactivate(productId)
          }
          this.$snack('Produto(s) desativado(s) com sucesso')
          await this.fetchData()
        })
      }
    },

    async confirmReactivate() {
      let proceed = await this.$confirmDeactivate(
        `Deseja reativar o produto selecionado?`
      )
      if (proceed) {
        this.$loading(async () => {
          for (let productId of this.selectedIds) {
            await ProductType.reactivate(productId)
          }
          this.$snack('Produto(s) reativado(s) com sucesso')
          await this.fetchData()
        })
      }
    }
  }
}
</script>

<style></style>
